var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlShareAndroid24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Control/ShareAndroid24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconShareAndroid",
    transform: "translate(3.000000, 3.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2629558,5.04380122 L5.75330512,9.0497401 C5.79779906,9.23642038 5.82135565,9.43122183 5.82135565,9.63152521 C5.82135565,9.69192768 5.81921352,9.75182982 5.81500109,9.81115983 L12.5934293,13.9825003 C12.968805,13.7572829 13.4081792,13.6277965 13.8777965,13.6277965 C15.2585084,13.6277965 16.3777965,14.7470846 16.3777965,16.1277965 C16.3777965,17.5085084 15.2585084,18.6277965 13.8777965,18.6277965 C12.4970846,18.6277965 11.3777965,17.5085084 11.3777965,16.1277965 C11.3777965,15.9520927 11.3959224,15.7806223 11.4304062,15.6151534 L4.88152292,11.5850713 C4.45388306,11.9270454 3.91149876,12.1315252 3.32135565,12.1315252 C1.94064377,12.1315252 0.821355646,11.0122371 0.821355646,9.63152521 C0.821355646,8.25081334 1.94064377,7.13152521 3.32135565,7.13152521 C3.76379039,7.13152521 4.17938174,7.24645543 4.5399032,7.44808935 L11.3799043,3.2388579 C11.3785037,3.20449748 11.3777965,3.16995827 11.3777965,3.13525391 C11.3777965,1.75454203 12.4970846,0.635253906 13.8777965,0.635253906 C15.2585084,0.635253906 16.3777965,1.75454203 16.3777965,3.13525391 C16.3777965,4.51596578 15.2585084,5.63525391 13.8777965,5.63525391 C13.2622067,5.63525391 12.6985832,5.41275975 12.2629558,5.04380122 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlShareAndroid24);
export default __webpack_public_path__ + "static/media/controlShareAndroid24.615387ce18e2b2cc6a1c73ade79d87cd.svg";
export { ForwardRef as ReactComponent };